<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="userDetails-modal">
<!-- <div class="modal-content upgradeManager-modal"> -->
    <p-confirmDialog key="cd" #cd>
        <ng-template #footer>
          <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
          <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </ng-template>
    </p-confirmDialog>

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">User Details</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body" style="padding: 15px;">
        <div style="display: flex; gap: 10px; margin-bottom: 15px; margin-top: 10px;">
            <label style="font-weight: 500; margin-left: 5px;">User: </label>
            <label>{{ userInfo.userName }}</label>
            <label style="font-weight: 500; margin-left: 100px;">Status: </label>
            <label *ngIf="userInfo.isGraphUser == undefined">Not able to verify</label>
            <label *ngIf="userInfo.isGraphUser != undefined && userInfo.isGraphUser == true">Current</label> 
            <label *ngIf="userInfo.isGraphUser != undefined && userInfo.isGraphUser == false" style="color: red;">User not in AD</label>
        </div>

        <tabset>  
            <tab heading="Associated User Groups ( {{ associatedUserGroups.length }} )" active="true" class="tabset">
                <p-table #userGroupAssociations [columns]="userGroupCols" [value]="associatedUserGroups" [scrollable]="true" scrollHeight="30em" class="data-table-device">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; height: 20px; display: flex; align-items: center; ">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="20" placeholder="Search" (input)="userGroupAssociations.filterGlobal($event.target.value, 'contains')" style="height: 30px">
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                        <tr style="height: 40px;">
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.name }}
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="cursor: pointer; flex: none; border-width: 0px;" class="text-center">
                                {{ rowData.userInfos.length }}
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;" class="text-center">
                                <div *ngIf="userIsAdmin">
                                    <p-checkbox id="{{rowData.id}}" name="{{rowData.id}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="userGroupSelected(rowData)"></p-checkbox>
                                </div>
                                <div *ngIf="!userIsAdmin">
                                    <i class="fa-solid fa-check"></i>
                                    <!-- {{ rowData.status }} -->
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tab>

            <tab heading="Associated Categories" class="tabset">
                <p-table #userCategory [columns]="userCategoryCols" [value]="userAssociatedCategories" [scrollable]="true" scrollHeight="30em" class="data-table-device">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; height: 20px; display: flex; align-items: center; ">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="20" placeholder="Search" (input)="userCategory.filterGlobal($event.target.value, 'contains')" style="height: 30px">
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                        <tr style="height: 40px;">
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.category }}
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;" class="text-center">
                                {{ rowData.itemCount }}
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;" class="text-center">
                                {{ rowData.userOwnedCount }}
                            </td>

                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;" class="text-center">
                                {{ rowData.groupOwnedCount }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tab>

            <tab heading="Associated Items ( {{ userAssociatedItems.length }} )" class="tabset">
                <p-table #userItems [columns]="userItemsCols" [value]="userAssociatedItems" [scrollable]="true" scrollHeight="30em" class="data-table-device">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; height: 20px; display: flex; align-items: center; ">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="20" placeholder="Search" (input)="userItems.filterGlobal($event.target.value, 'contains')" style="height: 30px">
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                        <tr style="height: 40px;">
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                 {{ rowData.name }}
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.type }}
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.ownerName }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tab>
        </tabset>

        <div *ngIf="userIsAdmin" style="display: flex; gap: 10px; margin-top: 20px;">
            <label style="font-size: 14px; margin-top: 6px;">Switch User Owned Items to </label>
            <ngx-select-dropdown name="userGroupSelection" style="height:32px; width: 280px; border-color: black;"
                [config]="userGroupconfig"
                [options]="allUserGroups"
                [(ngModel)]="selectedUserGroup">
            </ngx-select-dropdown>

            <button type="button" class="btn btn-basic" (click)="bsModalRef.hide()">Cancel</button>
            <button type="button" class="btn btn-success" (click)="updateUserDetails(userInfo, bsModalRef)" style="margin-right: 5px; height: 38px;">Update</button>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </div>          
    </div>
</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      <span>Loading...</span>
    </div>
</ng-template>